import type {
  GetUserClubsResponse,
  PlayerListElement
} from '@ps/web-shared-api-types/v0/SwHomeGames';
import produce from 'immer';

import { PKR_INITIAL_STATE, sortClubs } from '@swf/poker';

import type { Loading, PageData, UILayout } from '../types/common';

export interface GameSelect {
  gameId: string;
  select: boolean;
}

export { setClubInfo } from './reducers/clubInfo';
export { setClubMembers } from './reducers/clubMembers';
export { setClubOptions } from './reducers/clubOptions';
export { setClubSeasons } from './reducers/clubSeasons';
export { setClubSeasonStats } from './reducers/clubSeasonStats';
export { setError } from './reducers/error';
export { setPlayerTournamentResults } from './reducers/playerTournamentResults';
export {
  setRecentTournamentSummary,
  clearRecentTournamentSummary
} from './reducers/recentTournamentSummary';
export { setRegisteredTournaments } from './reducers/registeredTournaments';
export { setUserClubsAndGames } from './reducers/userClubsAndGames';
export { setScheduledRingGames } from './reducers/scheduledRingGames';
export { setLocalStorageItem } from './reducers/localStorageItem';
export { setTournamentStructures } from './reducers/tournamentStructures';
export { setTableStructures } from './reducers/tableStructures';
export { setWallPosts, clearWallPosts } from './reducers/wallPosts';
export { setAnnouncement, clearAnnouncement } from './reducers/announcement';
export { updateServiceStatusData, clearServiceStatus } from './reducers/serviceStatus';
export { setClubSeasonRanks, clearClubSeasonRanks } from './reducers/clubSeasonRanks';

export const setUserClubs = (state = PKR_INITIAL_STATE, payload: GetUserClubsResponse) =>
  produce(state, (draft) => {
    draft.clubs = sortClubs({ clubs: payload?.userClubs?.clubInfoList, prevClubs: state.clubs });
  });

export const setLoading = (state: PageData, { loaderName, isLoading }: Loading) =>
  produce(state, (draft) => {
    draft.loading[loaderName] = isLoading;
  });

export const setUiLayout = (
  state: PageData,
  { key, value }: { key: keyof UILayout; value: boolean }
) =>
  produce(state, (draft) => {
    draft.uiLayout[key] = value;
  });

export const reset = (state: PageData, payload?: { keepError?: boolean }) =>
  produce(state, (draft) => {
    if (payload?.keepError) PKR_INITIAL_STATE.error = state.error;
    return PKR_INITIAL_STATE;
  });

export const gameSelect = (state: PageData, { gameId, select }: GameSelect) =>
  produce(state, (draft) => {
    if (select) {
      draft.games.selectedGameIds = [gameId];
    } else {
      const index = state.games.selectedGameIds.indexOf(gameId);

      draft.games.selectedGameIds.splice(index, 1);
    }
  });

export const setPlayersByClubId = (
  state: PageData,
  { clubId, response }: { clubId: string | number; response: PlayerListElement[] }
) =>
  produce(state, (draft) => {
    draft.playersByClubId[clubId] = response;
  });
